import { useState } from "react";
import { CrossIcon, UsersIcon } from "../../Icons";
import CustomModal from "../CustomModal";
import AccessControlList from "./AccessControlList";
import AccessControlInput from "./AccessControlInput";

export default function AccessControlBtn({
  tableTitle,
  tableId,
}: {
  tableTitle: string;
  tableId: number;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <div>
      <button
        className={`p-1 rounded-lg hover:text-custom-blue-medium hover:scale-90 hover:bg-gray-100`}
        title="Pin sheet"
        onClick={toggleModal}
      >
        <UsersIcon />
      </button>

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="bg-white rounded-2xl shadow-2xl p-6 max-w-lg w-full relative text-gray-800"
      >
        <button
          onClick={toggleModal}
          className="absolute top-5 right-5 hover:scale-90 transition-transform"
        >
          <CrossIcon className="size-6 text-gray-600 hover:text-red-500" />
        </button>

        <h2 className="inline-flex items-center gap-1">
          <UsersIcon />
          Share <i className="font-medium">{tableTitle}</i> sheet
        </h2>

        <div className="space-y-4 mt-4">
          <AccessControlInput tableId={tableId} />

          <AccessControlList tableId={tableId} />
        </div>
      </CustomModal>
    </div>
  );
}
